import ConversationEffect from "src/Animations/ConversationEffect";
import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_DIGITAL_TWIN_INLCM_5 = {
  title: `<span style="color: #BEE3FF;">Generate the proposed network plan</span>\n\nGen AI generated planning brief.`,
  subtitle: "Digital Twin for Network Transformation",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ENG_3144"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_313"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/INLCM/INLCM_dark_bg_2.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "ENG/INLCM/INLCM_digital_twin_01_computer.png",
          effect: "animate-opacity",
          imageStyle: { position: "absolute", bottom: "160px", right: "0px" },
        },
        {
          image: "ENG/INLCM/INLCM_digital_twin_04_screen.png",
          imageStyle: { position: "absolute", bottom: "275px", right: "83px" },
        },
        {
          image: "ENG/INLCM/INLCM_digital_twin_05_popup.png",
          imageStyle: {
            position: "absolute",
            bottom: "165.58px",
            right: "705px",
          },
        },
      ]}
      pageNumber={"ENG_314"}
    />
  ),
};
